<template>
  <div>
    <Modal class="AddInfoModel" width="902" v-model="detailValue" :closable="false" :mask-closable="false"
      :footer-hide="true">
      <!-- 上面提示文字 -->
      <div class="tip-header">
        <span>查看详情</span>
        <span class="iconfont ys-iconguanbi" @click="handleReset('formValidate')"></span>
      </div>
      <!-- 内容区 -->
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
        <div class="wrapper">
          <FormItem label="发送人" style="width: 50%;margin-right: 10px;">
            <Input v-model="formValidate.crt_user_name" placeholder="请输入发送人" disabled />
          </FormItem>
          <FormItem label="主题" style="width: 50%">
            <Input v-model="formValidate.msg_title" placeholder="请输入主题" disabled />
          </FormItem>
        </div>
        <FormItem label="内容">
          <Input type="textarea" v-model="formValidate.msg_text" placeholder="请输入内容" :autosize="{minRows: 5,maxRows: 8}"
            disabled />
        </FormItem>
        <FormItem label="附件" v-if="formValidate.bk_name && formValidate.bk_name.length > 0">
          <!-- 上传文件展示 -->
          <upload-style
            :uplodData="formValidate.bk_name"
            :closeBtnStatus="false"
            :uploadStyle="true"
            @on-handle-item='onHandleItem'
          ></upload-style>
        </FormItem>
      </Form>
      <!-- 按钮组 -->
      <div class="btn-box">
        <Button class="ys-cancel" @click="handleReset('formValidate')"
          style="width: 100px; margin-right: 20px">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import UploadStyle from '_g/commonComponent/uploadStyle/index.vue'
  export default {
    components:{
      'upload-style': UploadStyle
    },
    props: {
      detailValue: {
        type: Boolean,
        default: false
      },
      modelData: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        formValidate: {
          msg_title: '', // 主题
          msg_text: '', // 内容
          crt_user_name: '', //发送人
          first_bk_fname: '', //文件名
        }
      }
    },
    methods: {
      // 取消
      handleReset(name) {
        this.$refs[name].resetFields();
        this.$emit('on-detail-click');
      },
      onHandleItem(res) {
        let dwoUrl = `${this.$ysConfig.serviceProxy.BaseUrl}webDownLoad/${this.formValidate.file_path}${res}`;
        window.open(dwoUrl);
      }
    },
    mounted() {
      this.formValidate = {
        ...this.formValidate,
        ...this.modelData
      }
    }
  }
</script>
<style lang="less" scoped>
  .AddInfoModel {
    .tip-header {
      width: 100%;
      height: 30px;
      line-height: 30px;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      margin-bottom: 24px;

      span:nth-of-type(1) {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(179, 195, 226, 1);
      }

      span:nth-of-type(2) {
        font-size: 28px;
      }

      span:nth-of-type(2):hover {
        cursor: pointer;
      }
    }

    .btn-box {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-end;
      margin-top: 40px;
    }

    .content-box {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      margin-bottom: 10px;
    }

    .wrapper {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
    }
  }
</style>